import { render } from "./FollowCarInput.vue?vue&type=template&id=0ed8c43d&scoped=true"
import script from "./FollowCarInput.vue?vue&type=script&lang=js"
export * from "./FollowCarInput.vue?vue&type=script&lang=js"

import "./FollowCarInput.vue?vue&type=style&index=0&id=0ed8c43d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed8c43d"]])

export default __exports__